import React, { useState, useEffect } from 'react';
import { message, Image } from 'antd';
import type { IAppList } from '../index';
import Requests from '@/services/request';
import { Grid, Radio, Icon, Slider } from '@alifd/next';
import Button from '@/components/Button';
import './index.less';
import $i18n from '../../../../../i18n';

const { Row, Col } = Grid;

const MiniAppOperate: React.FC<{ data: IAppList; onBack: () => void }> = ({ data, onBack }) => {
  const [specCode, setSpecCode] = useState(data?.specs?.[0]?.specCode || '');
  const [myTplList, setMyTplList] = useState<IAppList[]>([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const queryMyTpl = () => {
    Requests.get('/rest/intercnn/miniapp/tpl/myTpl', {}).then((res) => {
      setMyTplList(res || []);
    });
  };

  const queryAddToMyTpl = async () => {
      const res = await Requests.post('/rest/intercnn/miniapp/tpl/addToMyTpl', {
        specCode,
      })
      if (res === 'success') {
        message.success(
          $i18n.get({ id: 'aopf.miniAppTemplate.template.AddedSuccessfully', dm: '添加成功' }),
        );
        queryMyTpl();
      }
  };

  useEffect(() => {
    queryMyTpl();
  }, []);

  return (
    <div className="templateContainer">
      <div className="header">
        <Icon type="arrow-left" onClick={onBack} style={{ cursor: 'pointer' }} />
      </div>
      <div className="content">
        <div className="details">
          {data.specs?.find((v) => v.specCode === specCode)?.imgs ? (
            <div className="img-content">
              <Slider
                activeIndex={activeIndex}
                autoplay={false}
                onChange={(index)=> setActiveIndex(index)}
                dotsRender={(index) => {
                  if (activeIndex !== index) return;
                  return (
                    <div className="custom-dots">
                      <Icon
                        size="xs"
                        type="arrow-left"
                        onClick={() => setActiveIndex(index === 0 ? 2 : index - 1)}
                      />

                      <span>{index + 1}/3</span>
                      <Icon
                        size="xs"
                        type="arrow-right"
                        onClick={() => setActiveIndex(index === 2 ? 0 : index + 1)}
                      />
                    </div>
                  );
                }}
              >
                {(data.specs?.find((v) => v.specCode === specCode)?.imgs || [])
                  ?.slice(0, 3)
                  .map((item) => (
                    <div key={item.imgUrl} className="slider-img-wrapper">
                      <img src={item.imgUrl} alt={item.imgDesc} />
                    </div>
                  ))}
              </Slider>
            </div>
          ) : null}
          <div className="info-content">
            <div className="title">{data.tplName || ''}</div>
            <div className="introduce">{data.tplDesc || ''}</div>
            <Radio.Group
              size="large"
              shape="button"
              onChange={(value: any) => setSpecCode(value)}
              value={specCode}
            >
              {(data.specs || []).map((v) => (
                <Radio value={v.specCode} key={v.specCode}>
                  {v.specName}
                </Radio>
              ))}
            </Radio.Group>
            <div className="btns">
              <Button
                type="primary"
                size="large"
                loading={loading}
                disabled={!!myTplList.find((v) => v.specCode === specCode)}
                onClick={queryAddToMyTpl}
              >
                <Icon type="add" />
                {$i18n.get({
                  id: 'aopf.miniAppTemplate.template.AddToMyTemplateLibrary',
                  dm: '加入我的模板库',
                })}
              </Button>
              <div className="tip">
                {$i18n.get({
                  id: 'aopf.miniAppTemplate.template.GoToTheIdePlug',
                  dm: '(请前往IDE插件中编辑)',
                })}
              </div>
            </div>
          </div>
        </div>
        <Image.PreviewGroup
          preview={{
            className: 'app-template-image-preview',
            maskStyle: { backgroundColor: 'rgba(0, 0, 0, 0.8)' },
          }}
        >
          <Row className="img-details" gutter={16} wrap>
            {(data.specs?.find((v) => v.specCode === specCode)?.imgs || []).map((vv) => (
              <Col span={6} key={`${vv.imgDesc}_${vv.imgUrl}_${specCode}`}>
                <div className="img-desc" title={vv.imgDesc}>
                  {vv.imgDesc}
                </div>
                <Image className="img-url" src={vv.imgUrl} />
              </Col>
            ))}
          </Row>
        </Image.PreviewGroup>
      </div>
    </div>
  );
};

export default MiniAppOperate;
